<template>
    <div class="create-project-component">
        <pagination-component v-bind:steps="steps" v-bind:step-index="stepIndex" @stepIndexChanged="onStepIndexChanged">
            <template v-slot:content_0>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-8 col-sm-11">
                            <div class="inner-form styled-form">
                                <div class="form-group row">
                                    <div class="col">
                                        <input placeholder="Project name"
                                               id="name" type="text" class="form-control"
                                               v-bind:class="{ 'is-invalid': errorsContain('name') }"
                                               name="name" v-model="projectFormObj.name" required>

                                        <span v-if="errorsContain('name')" class="invalid-feedback" role="alert">
                                            <strong>The name is required.</strong>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col">
                                            <textarea rows="4" class="form-control" id="description" name="description"
                                                      v-bind:class="{ 'is-invalid': errorsContain('description') }"
                                                      placeholder="Project description"
                                                      v-model="projectFormObj.description">
                                                        {{ projectFormObj.description }}
                                            </textarea>
                                        <span v-if="errorsContain('description')" class="invalid-feedback" role="alert">
                                            <strong>The description is required.</strong>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row mt-5">
                                    <div class="col">
                                        <input type="file" ref="file" style="display: none"
                                               @change="processFile">
                                        <button class="btn btn-primary form-control"
                                                v-bind:class="{ 'is-invalid': errorsContain('file') || errorsContain('filetype') }"
                                                @click="$refs.file.click()">
                                            Upload .csv or excel file
                                        </button>
                                        <span v-if="projectFormObj.file" class="file-name">
                                            <strong>{{ projectFormObj.file.name }}</strong> <a @click="removeFile"
                                                                                               class="delete-file-btn"><i
                                            class="fas fa-times"></i></a>
                                        </span>
                                        <span v-if="errorsContain('file')" class="invalid-feedback" role="alert">
                                            <strong>The file is required.</strong>
                                        </span>
                                        <br>
                                        <span v-if="errorsContain('filetype')" class="invalid-feedback" role="alert">
                                            <strong>The file must be of one of the following types: .csv, .xlxs, .xls</strong>
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:content_1>
                <title-strip v-bind:title="project.name"></title-strip>
                <div class="container container-lg">
                    <div v-if="previewData" class="row mt-2">
                        <div class="col">
                            <data-table v-bind:data="previewData" v-bind:dataTable="true"></data-table>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:content_2>
                <title-strip v-bind:title="project.name"></title-strip>
                <project-select-recipe
                    v-bind:recipes="recipes"
                ></project-select-recipe>
            </template>
            <template v-slot:content_3>
            </template>
        </pagination-component>
        <modal-component></modal-component>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        props: {
            recipePublicUrl: String,
            postProjectUrl: String,
            viewProjectUrl: String,
            requestRecipeUrl: String,
            parseDataSetUrl: String,
            recipes: Array,
            projectStatesLookup: Array,
            recipeId: Number
        },
        data: function () {
            return {
                steps: [
                    {
                        title: 'Upload',
                        allowNext: false,
                        hasNextButton: true,
                        disabled: false
                    }, {
                        title: 'Preview',
                        allowNext: false,
                        hasNextButton: true,
                        disabled: false
                    }, {
                        title: this.recipeId ? 'Run analysis' : 'Select recipe',
                        allowNext: false,
                        hasNextButton: false,
                        disabled: false
                    }, {
                        title: 'Results',
                        allowNext: false,
                        hasNextButton: false,
                        disabled: true
                    }
                ],
                projectFormObj: {
                    name: '',
                    description: '',
                    recipe: null,
                    file: null
                },
                projectFormErrors: [],
                stepIndex: 0,
                previewData: {}
            }
        },
        created() {
            this.setUrls({
                postProjectUrl: this.postProjectUrl,
                viewProjectUrl: this.viewProjectUrl,
                requestRecipeUrl: this.requestRecipeUrl,
                parseDataSetUrl: this.parseDataSetUrl,
                apiUrl: process.env.MIX_API_URL,
                recipePublicUrl: this.recipePublicUrl
            });
            this.setProjectStates(this.projectStatesLookup);
            if (this.recipeId)
                this.assignRecipeToProject();
        },
        computed: {
            ...mapGetters([
                'urls',
                'projectStates',
                'project'
            ])
        },
        mounted() {
            this.projectFormErrors = [];
            this.closeModal();
            this.setLoading();
            console.log(this.urls);
        },
        methods: {
            ...mapActions([
                'closeModal',
                'openModal',
                'setLoading',
                'setUrls',
                'setMessage',
                'setProjectStates',
                'setProject',
                'setColumns',
                'handleError'
            ]),
            assignRecipeToProject: function () {
                for (let i = 0; i < this.recipes.length; i++) {
                    if (this.recipes[i].id === this.recipeId) {
                        this.setProject({
                            ...this.project,
                            recipe: this.recipes[i],
                            recipe_id: this.recipes[i].id
                        });
                    }
                }
            },
            errorsContain: function (inputName) {
                return this.projectFormErrors.includes(inputName);
            },
            onStepIndexChanged: function (index) {
                 if (index <= this.stepIndex) {
                    // we need to check if we are going back from the "select recipe" step,
                    // in order to clear the selection and not go to the previous step.
                    if(this.project.recipe_id) {
                        this.setProject({
                            ...
                                this.project,
                            recipe: null,
                            recipe_id: null
                        });
                    } else {
                        this.stepIndex = index;
                    }
                    return;
                }

                if (index === 1) {
                    // check if project name, description and file exist
                    if (this.isProjectFormValid()) {
                        this.postProject();
                    }
                } else if (index === 2) {
                    this.steps[this.stepIndex].allowNext = true;
                    this.stepIndex = index;
                } else if (index === 3) {
                    if (this.project.recipe) {
                        this.steps[this.stepIndex].allowNext = true;
                        this.stepIndex = index;
                    }
                }
            },
            processFile() {
                const file = this.$refs.file.files[0];

                if (!this.fileMIMETypeIsValid(file)) {
                    this.projectFormErrors.push('filetype');
                } else {
                    this.projectFormObj.file = file;
                    this.removeError('file');
                    this.removeError('filetype');
                }
            },
            fileMIMETypeIsValid(file) {
                return file.type
                    && (file.type.includes('text/csv') || file.type.includes('application/vnd.ms-excel')
                        || file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'))
            },
            removeError(errorName) {
                const index = this.projectFormErrors.indexOf(errorName);
                if (index > -1) {
                    this.projectFormErrors.splice(index, 1);
                }
            },
            removeFile: function () {
                this.projectFormObj.file = null;
                this.$refs.file.value = null;
            },
            isProjectFormValid: function () {

                this.projectFormErrors = [];

                if (!this.projectFormObj.name) {
                    this.projectFormErrors.push('name');
                }
                if (!this.projectFormObj.description) {
                    this.projectFormErrors.push('description');
                }
                if (!this.projectFormObj.file) {
                    this.projectFormErrors.push('file');
                }

                return this.projectFormErrors.length === 0;
            },
            getHeadersWithTypes(apiResponse) {
                const featureTypes = apiResponse.data.featureTypes;
                let modelColumns = apiResponse.data.parsedData.headers;

                for (let i = 0; i < modelColumns.length; i++) {
                    modelColumns[i].type = featureTypes[i].value;
                }
                return modelColumns;
            },
            postProject: function () {
                let instance = this;
                this.openModal();
                this.setLoading(true);
                this.setMessage('');
                this.projectFormObj.state_id = this.projectStates[0].id;
                axios.post(this.urls.postProjectUrl, this.projectFormObj)
                    .then(function (response) {
                        // append new fields to existing project instance
                        instance.setProject({
                            ...instance.project,
                            ...response.data.project
                        });
                        return instance.getPromiseForDataSetUpload();
                    })
                    .then(function (response) {
                        console.log(response);
                        response.data = JSON.parse(response.data);

                        const headers = response.data.parsedData.headers;
                        const rows = response.data.parsedData.rows;

                        instance.previewData.headers = headers;
                        instance.previewData.rows = rows;

                        instance.setProject({
                            ...instance.project,
                            model_columns: JSON.stringify(instance.getHeadersWithTypes(response)),
                            state_id: instance.projectStates[1].id,
                            num_of_rows: rows.length
                        });
                        instance.setColumns(headers);
                        return axios.post(instance.urls.postProjectUrl, instance.project);
                    })
                    .then(function (response) {
                        instance.closeModal();
                        // go to next step
                        instance.stepIndex = 1;
                    })
                    .catch(error => {
                        instance.handleError(error);
                    })
                    .finally(() => instance.setLoading(false))
            },
            getPromiseForDataSetUpload() {
                const formData = new FormData();
                formData.append('datasetFile', this.projectFormObj.file);
                formData.append('projectCode', this.project.code);

                return axios.post(this.urls.parseDataSetUrl, formData);
            }
        }
    }
</script>
<style lang="scss">

    @import "../../sass/variables";

    .create-project-component {
        width: 100%;
    }

    .loader-lg {
        margin: 0;
    }

    .file-name {
        color: $blue-dark;
    }

    .delete-file-btn {
        &:hover {
            cursor: pointer;
        }
    }

    .link {
        color: $red;
    }

</style>
